class Adminbar {

  hasAdminbar(){
    return document.body.classList.contains('admin-bar');
  }

  changeMarginTop(){
    if(this.hasAdminbar){
      let el = document.querySelector(".setHeaderMargin");
      if(window.innerWidth > 783){
        el.setAttribute("data-margin-top", '32');
      }
    }
  }

} export default new Adminbar;
